// extracted by mini-css-extract-plugin
export default {"content":"content__content___3VFmv","content-frame":"content__content-frame___3iqG-","full-width":"content__full-width___2mDIf"};